<template>
  <SSettingsSecurity />
</template>

<script lang="ts">
export default {
  name: 'SettingsSecurity',
};
</script>

<script setup lang="ts">
import { SSettingsSecurity } from '@slg/web-customer-shared';
</script>
